import { Phone, FileText } from 'lucide-react';

const TERMINAL_IMAGES = [
    { src: process.env.REACT_APP_TERMINAL_IMG_1 || '/images/terminal-card.jpeg', alt: 'Contactloos betalen met pinpas op de Adyen S1U2 douchelezer' },
    { src: process.env.REACT_APP_TERMINAL_IMG_2 || '/images/terminal-watch.jpeg', alt: 'Betalen met smartwatch op de douchelezer' },
    { src: process.env.REACT_APP_TERMINAL_IMG_3 || '/images/terminal-phone.jpeg', alt: 'Contactloos betalen met telefoon (Apple Pay of Google Pay)' },
];

export function SeoContent() {
    return (
        <>
            {/* Kopen of leasen */}
            <section className="py-16 lg:py-20 px-4 bg-[#FBF7EE]" data-testid="section-kopen-leasen">
                <div className="max-w-4xl mx-auto">
                    <h2 className="text-3xl sm:text-4xl font-bold text-[#3D3B00] font-['Outfit'] mb-6 tracking-tight">
                        Kopen of leasen: wat past bij uw park?
                    </h2>
                    <p className="text-base lg:text-lg text-[#3D3B00]/75 leading-relaxed">
                        Leasen kan al vanaf &euro;39 per maand per terminal, inclusief software en beveiligde internetverbinding. Kopen is voordeliger bij langdurig gebruik en meerdere doucheruimtes. De calculator rekent beide opties door op basis van uw bezetting en tarief per douchebeurt, zodat u appels met appels vergelijkt.
                    </p>
                </div>
            </section>

            {/* Waarom Adyen S1U2 */}
            <section className="py-16 lg:py-20 px-4 bg-[#F5ECD7]/40" data-testid="section-waarom-s1u2">
                <div className="max-w-5xl mx-auto">
                    <h2 className="text-3xl sm:text-4xl font-bold text-[#3D3B00] font-['Outfit'] mb-6 tracking-tight">
                        Waarom de Adyen S1U2 als douchelezer?
                    </h2>
                    <p className="text-base lg:text-lg text-[#3D3B00]/75 leading-relaxed mb-10">
                        De S1U2 is een professionele betaalterminal, geen hobby-oplossing. Gasten betalen contactloos met pinpas, creditcard, Apple Pay of Google Pay. De terminal is gekoppeld aan een online portal waarin u tarieven aanpast, douchetijden instelt en transacties realtime volgt, ook als u meerdere locaties beheert.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6" data-testid="terminal-gallery">
                        {TERMINAL_IMAGES.map((img, i) => (
                            <div key={i} className="aspect-[4/5] rounded-2xl overflow-hidden bg-white shadow-md border border-[#3D3B00]/10">
                                <img
                                    src={img.src}
                                    alt={img.alt}
                                    loading="lazy"
                                    className="w-full h-full object-cover"
                                    data-testid={`terminal-img-${i}`}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Zo werkt het */}
            <section className="py-16 lg:py-20 px-4 bg-[#FBF7EE]" data-testid="section-zo-werkt-het">
                <div className="max-w-4xl mx-auto">
                    <h2 className="text-3xl sm:text-4xl font-bold text-[#3D3B00] font-['Outfit'] mb-6 tracking-tight">
                        Zo werkt het
                    </h2>
                    <p className="text-base lg:text-lg text-[#3D3B00]/75 leading-relaxed">
                        De gast scant zijn pas of telefoon bij de terminal, het ingestelde bedrag wordt afgeschreven en de douche start automatisch voor de ingestelde tijd. Geen muntautomaat, geen wisselgeld, geen storing door vastzittende muntjes.
                    </p>
                </div>
            </section>

            {/* Voor welke locaties */}
            <section className="py-16 lg:py-20 px-4 bg-[#F5ECD7]/40" data-testid="section-voor-welke-locaties">
                <div className="max-w-4xl mx-auto">
                    <h2 className="text-3xl sm:text-4xl font-bold text-[#3D3B00] font-['Outfit'] mb-6 tracking-tight">
                        Voor welke locaties?
                    </h2>
                    <p className="text-base lg:text-lg text-[#3D3B00]/75 leading-relaxed">
                        Campings en recreatieparken, jachthavens, camperplaatsen, zwembaden, sportaccommodaties en evenemententerreinen. Overal waar gasten betaald douchen.
                    </p>
                </div>
            </section>
        </>
    );
}

export function ContactCta() {
    return (
        <section className="py-16 lg:py-20 px-4 bg-[#3D3B00]" data-testid="section-contact-cta">
            <div className="max-w-3xl mx-auto text-center text-[#F5ECD7]">
                <p className="text-lg lg:text-xl leading-relaxed mb-8">
                    Liever direct overleggen? Bel Ralf Drewes op <a href="tel:+31634200253" className="underline hover:text-[#4CAF50] transition-colors">+31 6 34 20 02 53</a> of vraag een vrijblijvende offerte aan.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a
                        href="tel:+31634200253"
                        data-testid="cta-call-btn"
                        className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#4CAF50] text-white font-semibold rounded-lg hover:bg-[#43A047] transition-colors"
                    >
                        <Phone className="w-5 h-5" />
                        Bel +31 6 34 20 02 53
                    </a>
                    <button
                        onClick={() => document.getElementById('lead-form')?.scrollIntoView({ behavior: 'smooth' })}
                        data-testid="cta-quote-btn"
                        className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-[#3D3B00] font-semibold rounded-lg hover:bg-[#F5ECD7] transition-colors"
                    >
                        <FileText className="w-5 h-5" />
                        Offerte aanvragen
                    </button>
                </div>
            </div>
        </section>
    );
}
